
import { get, post, qspost,newPost } from './axios'; 

//测试
export const demo = data => newPost('camera/config/find/user', data);
export const demoVideo = data => newPost('download/video/dw/time', data);
                                         


//登录接口--博罗
// export const login = data => post('/loginCheck', data);
//登录接口--大亚湾
export const login = data => post('/login/token', data);
// 更新token
export const refreshToken = data => post('refresh/token', data)
// 手机号修改密码
export const changePasswordByPhonde = data => newPost('reset/password', data)
// 获取验证码
export const sendCode = data => newPost('/send/code', data)

//头部头像-企业名称 
export const getImages = params => get('a/govt/user/findUserInfo?date='+ new Date().getTime(), params);

//待办任务
export const taskNum = params => get('a/govt/business/msg/count?date='+ new Date().getTime(), params);

// 个人中心-数据
export const PersonalList = params => get('a/govt/user/findUserInfo?date='+ new Date().getTime(), params);

//个人中心-编辑保存信息 
export const saveUser = data => post('a/govt/user/saveUserInfo', data);

//个人中心-修改密码
export const changePassword = data => newPost('a/govt/user/changePassword', data);

//反馈管理-保存
export const feedbackSave = data => newPost('a/govt/feedback/save', data);

//反馈管理列表数据
export const feedbackList = data => newPost('a/govt/feedback/page', data);

//违法详情
export const reportDetails = params => get('a/govt/task/last/report?date='+new Date().getTime(), params);

//是否接入采集器
export const waterState = data => newPost('a/govt/relation/find/state', data);

//预警信息
export const warnDetails = data => newPost('a/govt/relation/last/warn', data);

//修改权限
export const permissionEdit = params => get('a/govt/permission/permission/list?date='+new Date().getTime(), params);

//是否为农污企业
export const business = data => qspost('a/govt/relation/business/info', data);

//农污预警详情
export const agriculturalDetails = params => get('a/govt/warn/agricultural/find?date='+new Date().getTime(), params);

// 获取访问记录
export const getLogRecord = data => get('a/govt/risk/log/page', data);





// WEBPACK FOOTER //
// ./src/http/api.js